<template>
  <div class="az-beans-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="97"
      height="96"
      viewBox="0 0 97 96"
      fill="none"
    >
      <g clip-path="url(#clip0_15_1838)">
        <g filter="url(#filter0_d_15_1838)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M43.0546 74.3953C43.0546 73.6542 43.2764 72.9298 43.6919 72.3136C44.1075 71.6975 44.6981 71.2172 45.3891 70.9336C46.0801 70.65 46.8404 70.5759 47.574 70.7204C48.3075 70.865 48.9814 71.2219 49.5102 71.7459C50.0391 72.2699 50.3993 72.9375 50.5452 73.6643C50.6911 74.3911 50.6162 75.1445 50.33 75.8292C50.0438 76.5138 49.5591 77.099 48.9372 77.5107C48.3153 77.9224 47.5842 78.1422 46.8362 78.1422C45.8333 78.1422 44.8714 77.7474 44.1622 77.0447C43.453 76.3421 43.0546 75.389 43.0546 74.3953ZM70.4316 56.5583C70.6709 57.3872 70.6568 58.2678 70.3912 59.0888C70.1256 59.9098 69.6203 60.6343 68.9392 61.1709C68.2581 61.7075 67.4318 62.032 66.5647 62.1034C65.6975 62.1748 64.8285 61.99 64.0673 61.5722C63.3061 61.1545 62.687 60.5226 62.2882 59.7563C61.8894 58.99 61.7288 58.1239 61.8266 57.2672C61.9245 56.4105 62.2764 55.6018 62.8379 54.9432C63.3995 54.2846 64.1455 53.8058 64.9816 53.5671C65.5377 53.4084 66.1199 53.3599 66.6949 53.4244C67.2699 53.4888 67.8265 53.665 68.3327 53.9429C68.8389 54.2207 69.2848 54.5947 69.645 55.0435C70.0051 55.4923 70.2724 56.0071 70.4316 56.5583ZM72.4336 43.9638C73.1523 43.7556 73.9172 43.7635 74.6314 43.9865C75.3456 44.2094 75.9769 44.6375 76.4453 45.2163C76.9137 45.7952 77.1981 46.4988 77.2625 47.2379C77.3268 47.9771 77.1683 48.7186 76.8069 49.3684C76.4456 50.0182 75.8976 50.547 75.2326 50.888C74.5675 51.2289 73.8153 51.3665 73.0712 51.2834C72.3271 51.2003 71.6247 50.9001 71.0529 50.4211C70.4812 49.942 70.0658 49.3055 69.8596 48.5923C69.5986 47.6468 69.7219 46.6377 70.2031 45.7812C70.6843 44.9248 71.485 44.2893 72.4336 44.011V43.9638ZM52.3021 66.6339C52.3021 65.7714 52.5602 64.9283 53.0438 64.2112C53.5275 63.494 54.2148 62.9351 55.0191 62.605C55.8233 62.275 56.7083 62.1886 57.562 62.3569C58.4158 62.5251 59.2 62.9405 59.8156 63.5503C60.4311 64.1602 60.8503 64.9372 61.0201 65.7832C61.1899 66.6291 61.1028 67.5059 60.7696 68.3028C60.4365 69.0996 59.8724 69.7807 59.1486 70.2598C58.4248 70.739 57.5739 70.9948 56.7034 70.9948C55.5361 70.9948 54.4166 70.5353 53.5912 69.7175C52.7658 68.8997 52.3021 67.7905 52.3021 66.6339ZM83.6037 19.2628C65.8321 42.1148 46.035 63.3476 24.4485 82.7077C37.4934 94.09 62.5823 81.5899 72.1158 71.5143C86.4796 56.3064 87.9096 38.6426 83.6037 19.2628ZM51.4123 8.51025C40.3821 35.2079 26.9493 60.8677 11.2764 85.1793C15.916 87.4149 18.1246 87.777 23.4315 86.4388L19.2209 82.7549C33.5438 70.0193 47.1696 56.5344 60.0401 42.358C61.1682 29.1653 57.3548 19.7981 51.4123 8.51025Z"
            fill="#008672"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_15_1838"
          x="5.27637"
          y="5.51025"
          width="86.4641"
          height="90.7192"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_1838"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_1838"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_15_1838">
          <rect
            width="95.7395"
            height="95.7395"
            fill="white"
            transform="translate(0.638672)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>
